import axios from 'axios'
import type { Pinia } from 'pinia'
import { useDeviceIdStore } from '@/stores/deviceIdStore'
import { BASE_API_URL } from '@/services/api'

const api = axios.create({
  baseURL: BASE_API_URL,
})

export function setupAxios(pinia: Pinia) {
  const deviceStore = useDeviceIdStore(pinia)

  api.interceptors.request.use((config: any) => {
    config.headers['Device-Id'] = deviceStore.deviceId
    return config
  })
}

export { api }
